module.exports = __webpack_public_path__ + "media/images/single75-8381d7f05a9b16fd6b243872179a1c3c.jpg";